import { classNames } from "primereact/utils";
import { React, useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { getConfiguredLabel, ReadObjectProp } from "../../common/commonHelper";
import {
  errorIcon,
  mandatoryFieldErrorIcon,
  svg,
  upload,
} from "../../common/labelConstants";
import { getControlClasses, getFormControl } from "./formControlHelper";
import { getCustomValidator } from "./helper/customValidator";
import {
  AppLocalStorage,
  AppLocalStorageItems,
} from "../../helpers/localStorageHelper";
import { getMasterData } from "../../store/listing/listingSlice";
import { IconTypes, RenderIcons } from "./icons";
const _props = {
  form: {},
  controlConfig: {
    field: "",
    type: "",
    label: "",
    rules: {},
    options: [],
    mappedChildField: "",
    dataMappingAtRuntime: "",
    mappedParentField: "",
  }
};
export function AppFormControl(props = _props) {
  const [fieldOptions, setFieldOptions] = useState(
    props?.controlConfig?.options
  );
  const dispatch = useDispatch();
  const form = props.form;
  const controlConfig = props.controlConfig;

  const errIcon = RenderIcons(IconTypes.Error);

  const {
    control,
    formState: { errors },
    getValues,
    watch,
    trigger,
    setValue,
  } = form;
  const error = ReadObjectProp(controlConfig.field, errors);
  const errMsg = error?.message && (
    <small className="rc_p-error">
      {errIcon} <div className="rc_error_msg">{error.message}</div>
    </small>
  );
  const requiredSymbol =
    controlConfig?.rules?.required?.value != false ? (
      <span className="required-field" style={{ color: "#EF2653" }}>
        *
      </span>
    ) : (
      ""
    );
  let rules = controlConfig.rules;
  if (rules?.pattern?.value) {
    rules.pattern.value = new RegExp(rules.pattern.value, "i");
  }
  if (rules.customValidator) {
    const id = form?.getValues("id");
    const optionalData = {
      token: AppLocalStorage.getStorageItem(AppLocalStorageItems.Key),
      id: id,
      field: controlConfig.field,
      userInfo: props.user
    };
    
      rules.validate = (val) => {
        return getCustomValidator(rules.customValidator)(val, optionalData, form, props.inputForm);
      };
  }

  // parent child relationship starts.
  const resetChild = () => {
    if (controlConfig.mappedChildField) {
      setValue(controlConfig.mappedChildField);
    }
  };

  useEffect(() => {
    let subscription;
    if (controlConfig.mappedParentField) {
      subscription = watch((value, { name, type }) => {
        if (name === controlConfig.mappedParentField) {
          const v = getValues(controlConfig.mappedParentField);
          if (v && controlConfig.dataMappingAtRuntime) {
            dispatch(
              getMasterData({
                name: v.val + ":" + controlConfig.dataMappingAtRuntime,
              })
            ).then((res) => {
              setFieldOptions(res?.payload?.data?.data);
            });
          } else {
            setFieldOptions([]);
          }
          resetChild();
        }
      });
    }
    return () => {
      if (subscription) subscription.unsubscribe();
    };
  }, [watch]);

  function onChange(_field, _value) {
    resetChild();
    _field.onChange(_value);
  }
  // parent child relationship ends.

  return (
    <div
      className={
        controlConfig.formControlClassName || getControlClasses(controlConfig)
      }
    >
      <div className={"field" + (error ? " field_error" : "")}>
        {controlConfig.label && !controlConfig.customLabel &&  (
          <label
            htmlFor={controlConfig.field}
            className={classNames({ "p-error": error })}
          >
            {controlConfig.label}
            {requiredSymbol}
          </label>
        )}
        <Controller
          name={controlConfig.field}
          control={control}
          rules={rules}
          render={({ field, fieldState }) =>
            getFormControl(
              { ...field, onChange: (val) => onChange(field, val) },
              fieldState,
              { ...controlConfig, options: fieldOptions },
              form,
              { requiredSymbol },
              props.setIsUploadComplete,
              props.existingDocInfo
            )
          }
        />
      </div>
      {errMsg}
    </div>
  );
}
